import clsx from 'clsx';

export function TextPostBodyWrapper({
  children,
  enlarged
}: {
  children: React.ReactNode;
  enlarged?: boolean;
}) {
  return (
    <div className={clsx('text-gray-900', enlarged ? 'text-base' : 'text-sm')}>{children}</div>
  );
}
